/*
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2022-06-23 09:04:23
 * @LastEditTime : 2022-11-21 11:49:31
 * @LastEditors  : yangxr
 * @Description  : 
 * @FilePath     : \icps_fb\src\api\smart\schedul\i.js
 */
/*
 * @Description:
 * @Autor: wangwangwang
 * @Date: 2021-03-05 16:36:51
 * @LastEditors: wangwangwang
 * @LastEditTime: 2021-05-11 14:15:46
 */
import request from "@/utils/request";
export const queryPage = "/icps/system/sign/basics/dispatch/get_pump_task";

// /*根据工程id获取图算列表*/
export function save_inform_driver(data) {
  return request({
    url: "/icps/system/sign/basics/dispatch/save_inform_driver",
    method: "post",
    data,
  });
}
export function queryDispatchInfor(data) {
  return request({
    url: "/icps/system/sign/basics/dispatch/queryDispatchInfor",
    method: "post",
    data,
  });
}
//完工申请
export function updateAssian(data) {
  return request({
    url: "/icps/system/sign/basics/dispatch/updateAssian",
    method: "post",
    data,
  });
}
//完工申请
export function updateAssianWait(data) {
  return request({
    url: "/icps/system/sign/basics/dispatch/updateAssianWait",
    method: "post",
    data,
  });
}

export function getAssian(data) {
  return request({
    url: "/icps/system/sign/basics/dispatch/getAssian",
    method: "post",
    data,
  });
}
export function get_pump_handover_amount(params) {
  return request({
    url: "/icps/system/sign/basics/dispatch/getOnDutyQuantityResord",
    method: "get",
    params,
  });
}
export function saveOrupdateQuantityResord(data) {
  return request({
    url: "/icps/system/sign/basics/dispatch/saveOrupdateQuantityResord",
    method: "post",
    data,
  });
}
export function appQuerySatation(params) {
  return request({
    url: "/icps/system/sign/basics/plan/appQuerySatation",
    method: "get",
    params,
  });
}

